@defer (on viewport) {
  <section>
    <header class="text-center">
      <h2 class="h3-responsive font-bold mb-5">
        <p>Contact Us</p>
      </h2>
      <p class="text-gray-500">Please check our rates and availability of funds by calling us.</p>
    </header>
    <section class="flex flex-col items-center gap-4 mt-4 font-bold h3-rsponsive !mt-10">
      <a class="btn-contact-us" mat-raised-button color="sky-blue" href="Tel:+1-825-436-2133"> {{ phoneNumber }} </a>

      <a class="btn-contact-us" mat-raised-button color="sky-blue" href="http://trustply.link/monisfersubmitreq" target="_blank"> Submit request </a>
    </section>
  </section>
} @placeholder {
  <div class="spinner-center">
    <mat-spinner></mat-spinner>
  </div>
}
